import LifelineCreationForm from '../components/LifelineCreationForm'

function LifelineCreation() {
  return <LifelineCreationForm />
}
export default LifelineCreation
